import React from "react";
import { compose, withPropsOnChange } from "recompose";
import { withTranslation } from "react-i18next";
import { Control } from "react-redux-form";
import Select from "react-select";

const withLineAmountTypes = ({
  lineAmountTypesKey = "lineAmountTypes",
  lineAmountTypeComponentKey = "LineAmountTypes",
} = {}) =>
  compose(
    withTranslation(),
    withPropsOnChange(["t"], ({ t }) => ({
      [lineAmountTypesKey]: [
        {
          label: t("Tax Inclusive"),
          value: "Inclusive",
        },
        {
          label: t("Tax Exclusive"),
          value: "Exclusive",
        },
        {
          label: t("No Tax"),
          value: "NoTax",
        },
      ],
    })),
    (BaseComponent) =>
      class extends React.Component {
        renderLineAmountTypes = (props) => (
          <Control.select
            component={Select}
            options={this.props[lineAmountTypesKey]}
            simpleValue
            clearable={false}
            searchable={false}
            {...props}
          />
        );

        render = () => {
          const props = {
            [lineAmountTypeComponentKey]: this.renderLineAmountTypes,
          };
          return <BaseComponent {...this.props} {...props} />;
        };
      }
  );

export default withLineAmountTypes;
